export const authCheck = () => {
  const url = new URL(globalThis.location.href);
  const isApkPath = url.pathname === '/apk';
  const isIframePath = url.pathname === '/iframe';
  const email = url.searchParams.get('email');
  const accessToken = url.searchParams.get('access_token');

  if (accessToken && accessToken.trim() !== '') {
    globalThis.localStorage.setItem('token', accessToken);
    globalThis.location.replace(`${import.meta.env.VITE_BASE_URL}`);
  } else if (
    (isApkPath || isIframePath) &&
    email &&
    email.trim() !== ''
  ) { 
    return;
  } else if (import.meta.env.VITE_CHATBOT_IFRAME_URL !== 'https://chat.kazee.ai') {
    const token = globalThis.localStorage.getItem('token');
    const isTokenInvalid = ['undefined', 'null', ''].includes(token ?? '');
    const isLoginPage = globalThis.location.pathname === '/auth/login';

    const slashDev =
      import.meta.env.VITE_BASE_URL === 'http://localhost:3000' ? '/dev' : '';
    const url = `${import.meta.env.VITE_API_BASE_URL}/v1/auth/login${slashDev}`;

    if (isTokenInvalid && !isLoginPage) {
      const redirectPath =
        globalThis.location.pathname === '/auth/login'
          ? ''
          : `?redirect=${globalThis.location.pathname}`;
      globalThis.location.replace(`${url}${redirectPath}`);
    }
  }
};
